import { render, staticRenderFns } from "./MobileBottomBar.vue?vue&type=template&id=3c414823"
import script from "./MobileBottomBar.vue?vue&type=script&lang=js"
export * from "./MobileBottomBar.vue?vue&type=script&lang=js"
import style0 from "./MobileBottomBar.vue?vue&type=style&index=0&id=3c414823&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports